"use client";
import { NotificationModel } from "@/types/notification";
import React from "react";
import { Separator } from "../ui/separator";
import { useRouter } from "next/navigation";
import { cn } from "@/lib/utils";
import { readNotification } from "@/services/notification.service";
import { Link } from "@/i18n/navigation";

const NotificationCard = ({
  notification,
}: {
  notification: NotificationModel;
}) => {
  const handleClick = async () => {
    // if (notification.type !== "order") return;
    // push(`/orders/${notification.data.model_id}`);
    if (notification.is_read) return;
    await readNotification(notification.id);
  };
  return (
    <div
      className={"px-4 py-3 transition cursor-pointer"}
      onClick={handleClick}
    >
      <div className="flex justify-between gap-2">
        <h4
          className={cn(
            "text-sm font-medium leading-snug",
            !notification.is_read && "font-semibold",
          )}
        >
          {notification.data.title}
        </h4>
        {!notification.is_read && (
          <span className="h-2 w-2 rounded-full bg-blue-500 mt-1" />
        )}
      </div>

      <p className="mt-1 text-sm text-muted-foreground line-clamp-3">
        {notification.data.body}
      </p>

      <span className="mt-2 block text-xs text-muted-foreground">
        {new Date(notification.date).toLocaleDateString("ar")}
      </span>

      {/* <Separator className="mt-3" /> */}
    </div>
  );
};

export default NotificationCard;
